import { AfterViewInit, Component, Input } from '@angular/core';
import { Stripe, StripeElements, StripeElementsOptions } from '@stripe/stripe-js';
import { StripeService } from '../../../core/services/stripe.service';
import { CustomButtonComponent } from "../custom-button/custom-button.component";
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-payment',
  standalone: true,
  imports: [CustomButtonComponent, TranslocoPipe],
  templateUrl: './payment.component.html',
  styleUrl: './payment.component.css'
})
export class PaymentComponent implements AfterViewInit {
  stripe: Stripe | null = null;
  elements: StripeElements | null = null;
  paymentElement: any | null = null;
  @Input() clientSecret!: string;
  @Input() isPayment: boolean = true;

  constructor(private stripeService: StripeService) { }

  async ngAfterViewInit(): Promise<void> {
    this.stripe = await this.stripeService.getStripe();

    if (!this.stripe) {
      console.error("Stripe failed to load");
      return;
    }

    const appearance: StripeElementsOptions["appearance"] = {
      theme: 'flat'
    };

    const options: StripeElementsOptions = {
      clientSecret: this.clientSecret,
      appearance: appearance,
    };


    this.elements = this.stripe.elements(options);
    this.paymentElement = this.elements.create('payment', { layout: "tabs" });

    this.paymentElement.mount('#payment-element');
  }

  async handleSubmit(event: Event) {
    event.preventDefault();

    if (!this.stripe || !this.elements) {
      console.error("Stripe not initialized");
      return;
    }

    const returnUrl = `${window.location.origin}/dashboard/overview`;
    let error;

    if (this.isPayment) {
      // immediate charge
      ({ error } = await this.stripe.confirmPayment({
        elements: this.elements,
        confirmParams: {
          return_url: returnUrl,
        },
      }));
    } else {
      // save card, no immediate charge
      ({ error } = await this.stripe.confirmSetup({
        elements: this.elements,
        confirmParams: {
          return_url: returnUrl,
        },
      }));
    }

    if (error) {
      const messageElement = document.getElementById('error-message');
      if (messageElement) {
        messageElement.textContent = error.message || 'Payment failed';
      }
    }
  }
}
